<script setup lang="ts">
import { computed } from 'vue';
import FormRow from '@/components/Common/FormRow.vue';
import DriverAutoComplete from '@/components/AutoCompletes/DriverAutoComplete.vue';
import getOperationOffice from '@/types/responses/getOperationOffice';
import getAccount from '@/types/responses/getAccount';
import i18n from '@/lang/i18n';

const props = defineProps<{
  modelValue: getAccount | undefined;
  operationOffice: getOperationOffice | null;
  initialDriverAccountId?: number;
  errorMessages?: string[];
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: getAccount | undefined): void
}>()

const driver = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})
</script>

<template>
  <FormRow
    :title="i18n.global.t('pages.gpsTrackerSetting.commonDriver')"
  >
    <DriverAutoComplete
      :key="props.operationOffice?.id"
      v-model="driver"
      :selected-department="null"
      :initial-item-id="props.initialDriverAccountId"
      :operation-offices="props.operationOffice ? [props.operationOffice] : []"
      :disabled="!props.operationOffice"
      :error-messages="props.errorMessages"
      class="autocomplete-width"
    />
  </FormRow>
</template>

<style scoped>
.autocomplete-width {
  max-width: 300px;
}
</style>
